<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        
        <b-card no-body>
            <b-tabs card>
                <b-tab 
                    v-for="page in pages"
                    :key="page.position"
                    :title="page.title"
                >
                    <b-card-text>
                        <multi-page-form-page
                            :schema="page.schema"
                        ></multi-page-form-page>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>

        <h5>Schema</h5>
        <pre>{{ formSchema }}</pre>
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
import MultiPageFormPage from './MultiPageFormPage';

export default {
    name: 'MultiPageForm',
    components: {
        MultiPageFormPage,
    },
    mixins: [
        errorHandling,
    ],
    props: {},
    data() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingForm: false,
            submittingForm: false,
            // FORM
            pages: [],  // will set from API
            formData: {},
            formSchema: null,
            finalSchema: null, 
        }
    },
    computed: {

    },
    mounted() {
        this.getForm();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getForm() {
            this.loadingForm = true;
            try {
                const { data } = await suppliosApi.workflowForms.getTestForm();
                this.pages = data;
                this.setFinalSchema(data);
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingForm = false;
        },
        setFinalSchema(apiSchema) {
            this.finalSchema = apiSchema;  // for now...
        },
        async handleSubmit(submitData) {
            this.submittingForm = true;
            // make this async and call it from form @submit -- then FormulateForm will automatically expose 'isLoading' property on the form context object
            console.log('HELLO FROM handleSubmit', submitData);
            try {
                const { data } = await suppliosApi.workflowForms.postTestForm(submitData);
                console.log('Response data from POSTing data to server', data);
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.submittingForm = false;
        },
    }
}
</script>

<style>

</style>